import * as R from 'ramda'
import { delay } from 'redux-saga'
import {
  put,
  call,
  take,
  select,
  takeLatest,
} from 'redux-saga/effects'

import {
  FETCH_EMPLOYEE_LIST_WITH_IMAGES
} from './constants'
import {
  FETCH_EMPLOYEE_LIST,
  FETCH_EMPLOYEE_LIST_START,
  FETCH_EMPLOYEE_LIST_SUCCESS,
  FETCH_EMPLOYEE_LIST_ERROR,
} from './EmployeeList/constants'

import {
  fetchEmployeeImage,
} from 'containers/User/EmployeeImage/actions'
import {
  fetchEmployeeList,
} from 'containers/User/EmployeeList/actions'

import {
  employeeListUsernameSelector,
  employeeUsernameSelector,
} from 'containers/User/EmployeeImage/selectors'

function* fetchEmployeeListWithImagesHandler(action) {
  const { username } = action
  yield call(delay, 500)
  yield put(fetchEmployeeList(username))
  const employeeListAction = yield take([FETCH_EMPLOYEE_LIST_SUCCESS, FETCH_EMPLOYEE_LIST_ERROR])

  if (employeeListAction.type === FETCH_EMPLOYEE_LIST_SUCCESS) {
    const usernames = yield select(employeeUsernameSelector)
    const missingUserImages = R.difference(Object.keys(employeeListAction.employees), usernames)

    for (let user of missingUserImages) {
      yield put(fetchEmployeeImage(user))
    }
  }
}

function* watchFetchEmployeeListWithImages() {
  yield takeLatest(FETCH_EMPLOYEE_LIST_WITH_IMAGES, fetchEmployeeListWithImagesHandler)
}

export { default as watchFetchEmployeeImage } from './EmployeeImage/sagas'
export { default as watchGetEmployeeList } from './EmployeeList/sagas'
export { default as watchLoginPage } from './Login/sagas'
export {
  watchFetchEmployeeListWithImages
}
